module.exports = __webpack_public_path__ + "static/media/Delink.a47db9ea.svg";